import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import type { FlightSearchTransitionPayload } from "@/feature/transition/lib/flight-search-transition.helper";
import type { HotelSearchTransitionPayload } from "@/feature/transition/lib/hotel-search-transition.utils";

export interface HolidaySearchTransitionPayload {
  startedAt: number;
  destination: {
    name: string;
    lat: number;
    lng: number;
  } | null;
}

export type TransitionType = "flight" | "holiday" | "visa" | "umrah" | "hotel" | null;

interface GlobalTransitionState {
  activeType: TransitionType;
  flightPayload: FlightSearchTransitionPayload | null;
  holidayPayload: HolidaySearchTransitionPayload | null;
  hotelPayload: HotelSearchTransitionPayload | null;
}

const initialState: GlobalTransitionState = {
  activeType: null,
  flightPayload: null,
  holidayPayload: null,
  hotelPayload: null,
};

const globalTransitionSlice = createSlice({
  name: "globalTransition",
  initialState,
  reducers: {
    startTransition: (
      state,
      action: PayloadAction<
        | { type: "flight"; payload: FlightSearchTransitionPayload }
        | { type: "holiday"; payload: HolidaySearchTransitionPayload }
        | { type: "hotel"; payload: HotelSearchTransitionPayload }
      >
    ) => {
      // Clear previous states
      state.activeType = action.payload.type;
      state.flightPayload = null;
      state.holidayPayload = null;
      state.hotelPayload = null;

      if (action.payload.type === "flight") {
        state.flightPayload = action.payload.payload as FlightSearchTransitionPayload;
      } else if (action.payload.type === "holiday") {
        state.holidayPayload = action.payload.payload as HolidaySearchTransitionPayload;
      } else if (action.payload.type === "hotel") {
        state.hotelPayload = action.payload.payload as HotelSearchTransitionPayload;
      }
    },
    finishTransition: () => initialState,
  },
});

export const { startTransition, finishTransition } = globalTransitionSlice.actions;

export default globalTransitionSlice;
